import React, { useState, useEffect } from 'react';
import { IconButton, Badge, Popover } from '@material-ui/core';
import { Notifications } from "@material-ui/icons";
import axios from 'axios';
import { NotificationType } from '../NotificationCard/NotificationCard.interface';
import { NotificationCard } from '../NotificationCard';
import {
  NoNotificationsWrapper,
  StyledPaper,
  NotificationWrapper,
  FlexWrapper
} from './NotificationPopper.styles';
import { NotificationApiResponse } from './NotificationPopper.interface';

export function NotificationPopper({ user, authToken }: any) {
  const [notifications, setNotifications] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popper' : undefined;
  const handleClick = (event: any) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };
  const notificationIcon = () => (
    <Badge badgeContent={notifications.length && notifications.filter((each: any) => !each.isRead).length} color="secondary">
      <Notifications />
    </Badge>
  );
  const fetchData = () => {
    axios.get(`${process.env.REACT_APP_BASE_URL}/api/notifications/notification/`, { headers: { DTOKEN: `${authToken}` } }).then(res => {
      const results = res.data.map((notification: NotificationApiResponse) => {
        return {
          id: notification.id,
          createAt: notification.create_at,
          isRead: notification.is_read,
          notificationType: notification.notification_type,
          additionalInformation: notification.additional_information,
          campaignTitle: notification.campaign_title,
          notificationUrl: notification.notification_url
        }
      })
      setNotifications(results);
    })
  }
  const handleClose = () => {
    setAnchorEl(null);
  }
  const markAllAsRead = () => {
    setNotifications([]);
    axios.patch(`${process.env.REACT_APP_BASE_URL}/api/notifications/notification/mark-all-as-read/`, {}, { headers: { DTOKEN: `${authToken}` } }).then(() => {
      fetchData();
    })
  }
  
  useEffect(() => {
    if (authToken) {
      fetchData();
    }
    const notificationInterval = setInterval(() => {
      if(authToken) {
        fetchData();
      }
    }, 5000);
    return () => clearInterval(notificationInterval)
  }, [authToken])

  return (
    <>
      <IconButton onClick={handleClick} aria-label="Show notifications" color="inherit">
        {notificationIcon()}
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <StyledPaper>
          <FlexWrapper>
            <p>Notifications</p>
            {notifications.length > 0 && <button onClick={markAllAsRead}>Mark all as read</button>}
          </FlexWrapper>
          {notifications.length > 0 ?
            <NotificationWrapper>
              {notifications.map((notification: NotificationType) => (
                <NotificationCard key={notification.id} data={notification} refresh={fetchData} closePopper={handleClose} />
              ))}
            </NotificationWrapper>
            :
            <NoNotificationsWrapper>
              <Notifications />
              <p>No notifications yet</p>
            </NoNotificationsWrapper>
          }
        </StyledPaper>
      </Popover>
    </>
  );
}
